// Customer pages script

// toggle reset password content in Login page
const pwResetOpenButton = document.querySelector("[data-pw-reset-open-btn]");
const pwResetCloseButton = document.querySelector("[data-pw-reset-close-btn]");
const loginContent = document.querySelector("[data-login-content]");
const pwResetContent = document.querySelector("[data-pw-reset-content]");

if (pwResetOpenButton && pwResetCloseButton && loginContent && pwResetContent) {

  pwResetOpenButton.addEventListener("click", () => {
    if (pwResetContent.dataset.pwResetContent === "close") {
      loginContent.dataset.loginContent = "close";
      pwResetContent.dataset.pwResetContent = "open";
    }
  })

  pwResetCloseButton.addEventListener("click", () => {
    if (pwResetContent.dataset.pwResetContent === "open") {
      loginContent.dataset.loginContent = "open";
      pwResetContent.dataset.pwResetContent = "close";
    }
  })

}
